// extracted by mini-css-extract-plugin
export default {"contacts":"contacts_contacts__r-R3O","contacts-info":"contacts_contacts-info__vrlyj","logo":"contacts_logo__h6wnR","contacts-container":"contacts_contacts-container__xNxO+"};